import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Grid, Container } from '@mui/material';
import { CalendarToday as CalendarTodayIcon, Event as EventIcon, Group as GroupIcon } from "@mui/icons-material";
import { getData } from "../../services/axiosInstance";
import { API_ENDPOINTS } from "../../services/endpoints";
import Loader from "../../common/spinner";
import PushNotificationManager from "../../services/PushNotificationManager";
import DashboardCard from "../../components/common/DashboardCard";

function HrDashboard() {
    const navigate = useNavigate();
    const [stats, setStats] = useState({});
    const userDataRaw = localStorage.getItem('userData');
    const userData = userDataRaw ? JSON.parse(userDataRaw) : null;
    const userId = userData?.id;
    const orgId = userData?.organization_id;
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            if (!orgId) return;
            setLoading(true);
            try {
                const url = `${API_ENDPOINTS.getHrDashboardCounts}?userId=${userId}`;
                const res = await getData(url);
                if (res.status === "SUCCESS") {
                    setStats(res.message?.data || {});
                }
            } catch (e) {
                return null;
            }
            finally {
                setLoading(false); // Stop loading regardless of success/fail
            }
        };
        fetchStats();
    }, [orgId, userId]);

    const cards = [
        { id: 1, icon: <CalendarTodayIcon />, title: "Total Employees", count: stats.totalActiveEmployees, p: "#4158D0", s: "#C850C0", path: "/hr/employee-management" },
        { id: 3, icon: <EventIcon />, title: "Attendance Overview", count: `${stats.attendanceToday?.percentage || "0"}%`, p: "#8EC5FC", s: "#E0C3FC", path: "/hr/attendance-management" },
        { id: 4, icon: <GroupIcon />, title: "Leave Requests", count: stats.totalLeaveRequests, p: "#FF3CAC", s: "#784BA0", path: "/hr/leave-management" }
    ];

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
                <Loader />
            </Box>
        );
    }

    return (
        <Box sx={{ p: 1 }}>
            <PushNotificationManager userId={userId} />
            <Container maxWidth="xl" sx={{ padding: '0 !important' }}>
                <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    {cards.map(c => (
                        <Grid key={c.id} size={{ xs: 2, sm: 4, md: 4 }}>
                            <DashboardCard
                                card={c}
                                onClick={() => c.path && navigate(c.path)}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Container >
        </Box>
    );
}

export default HrDashboard;